import { FunctionComponent } from 'react';
import './features-2.scss';
import BuyNowButton from '../../shared/buy-now-button/buy-now-button';
import H2 from '../../shared/html-tags/h2';
import H1 from '../../shared/html-tags/h1';
import DIV from '../../shared/html-tags/div';

export type Props = {};

const Features2TopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="page-content bg-top-features-2 top-banner" style={{ height: '25.25rem' }}>
      <div className="inner-content">
        <div
          className="top-left"
          style={{
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'center',
            marginLeft: '-8rem',
            paddingLeft: '8rem',
            backgroundImage: 'url(/img/features/2/52-bang-300x300.png)',
            backgroundPosition: '0 17rem',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '12.5rem',
            height: '25.25rem',
          }}
        >
          <div>
            <H2 language="de">Kinderleichte SPSS Auswertungen</H2>
            <H1 language="de" style={{ lineHeight: '1.25' }}>
              Datenanalyse und Statistik mit PS IMAGO PRO <b style={{ color: 'crimson' }}>PRO</b>
            </H1>
            <H2 language="de" style={{ fontSize: '1.25rem', marginTop: '0.5rem' }}>
              Erziele schneller, präzisere Ergebnisse,
              <br />
              während du Zeit und Kosten sparst.
            </H2>
            <BuyNowButton order={'buy'} />
          </div>
        </div>
        <DIV language="de" className="top-right">
          <img
            src="/img/features/2/p2-522x500.png"
            alt="Roboter liest die 2x4 PS IMAGO PRO News"
            style={{ border: 'none', marginTop: '0', maxHeight: '24.5rem' }}
          />
        </DIV>
      </div>
    </div>
  );
};

export default Features2TopBanner;
